module.exports = __webpack_public_path__ + "static/media/birthday-cake.03c886b8.svg";